import React from 'react';
import * as Tools from "../../helpers/Tools";
import { withRouter } from "react-router-dom";
import { Card, Divider, Thumbnail, Typography } from "../ecosystem";
import FavoriteDrButton from "./FavoriteDrButton";
import FavoriteDrSchedule from "./FavoriteDrSchedule";
import FavoriteDrRating from "./FavoriteDrRating";
import DrNameSpecialty from "./DrNameSpecialty";
import FavoriteDrNotReferable from "./FavoriteDrNotReferable";

const FavoriteDrCard = ({
    isMobile,
    isTablet,
    npi,
    onlineSchedulingEnabled,
    provider,
}) => {
    const provName = provider && provider?.displayName ? Tools.trimComma(provider?.displayName) : '';
    const provSpecialty = provider && provider?.specialties
        ? provider.specialties.map((specialty) => {
            return specialty.Specialty;
        }).join(", ")
        : '';
    const provUrl = npi ? "/providers/" + npi : '';
    const scheduleUrl = npi ? `/schedule/${npi}/OpenSchedule` : '';
    const showBookNow = provider && provider?.isOpenSchedulingAvailable && onlineSchedulingEnabled;
    const disableBookNow = (showBookNow && !(provider?.openSchedule && provider.openSchedule?.dateAndTimes)) ? true : false;

    const getPhoneNumber = () => {
        let location = null;
        let phone = '';
        if (provider?.locations && provider?.locations?.length > 0) {
            location = provider?.locations[0];
        }

        phone = provider?.consumerCallCenterNumber;
        if (location && location?.locationPhone && (!phone || phone === "")) {
            phone = location?.locationPhone;
        }

        return phone;
    }

    const isVerticalCard = isMobile || isTablet ? true : false;

    const favDrCardClasses = [
        'favorite-doctors-card-container',
        `favorite-doctors-card-container--${isVerticalCard ? 'vertical' : 'horizontal'}`
    ].join(' ');

    return (provider &&
        <Card
            className={favDrCardClasses}
        >
            <div className="favorite-doctors__fav-icon-button">
                <FavoriteDrButton NPI={npi} isMobile={isMobile} />
            </div>
            <div className="row favorite-doctors-card__content">
                <div className="col-12 col-xl-8 favorite-doctors__profile">
                    <div className="row">
                        <div className="col favorite-doctors__thumbnail">
                            <Thumbnail
                                source={provider.photo ? provider.photo : ''}
                                icon="doctor"
                                size={isMobile ? "md" : "lg"}
                                altText={provName}
                            />
                        </div>
                        <div className="col favorite-doctors__info">
                            <DrNameSpecialty
                                name={provName}
                                specialty={provSpecialty}
                                provUrl={provUrl}
                            />
                            <FavoriteDrRating
                                rating={provider.averageRatingStr}
                                count={provider.reviewCountStr}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12 col-xl-4 favorite-doctors__cta">
                    <Divider
                        orientation={isVerticalCard ? "horizontal" : "vertical"}
                        mLeft="none"
                        mRight="none"
                        mTop={isVerticalCard ? "small" : "none"}
                        mBottom={isVerticalCard ? "small" : "none"}
                    />
                    {provider.isReferable === true
                        ? <FavoriteDrSchedule
                            disableBookNow={disableBookNow}
                            orientation={isVerticalCard ? "horizontal" : "vertical"}
                            phone={getPhoneNumber()}
                            scheduleUrl={scheduleUrl}
                            showBookNow={showBookNow}
                            showPhone={!isMobile}
                            isMobile={isMobile}
                        />
                        : <FavoriteDrNotReferable
                            orientation={isVerticalCard ? "horizontal" : "vertical"}
                            isMobile={isMobile}
                        />
                    }
                </div>
            </div>
        </Card>
    );
}

export default withRouter(FavoriteDrCard);
